import Home from '@/components/marketing/Home'
import Jobs from '@/components/warboard/Jobs/JobHome'
import RFIs from '@/components/warboard/RFIs/RFIs'
import Transmittals from "@/components/warboard/Transmittals/Transmittals";
import ProjectJournal from "@/components/warboard/ProjectJournal/ProjectJournalHome";
import TimeTracking from "@/components/warboard/TimeTracking/TimeTracking";

import Login from "@/components/auth/Login";
import Logout from "@/components/auth/Logout";
import Dashboard from "@/components/warboard/Dashboard";

const routes = [
    {
        name: 'home',
        path: '/',
        component: Home,
    },
    {
        name: 'dashboard',
        path: '/dashboard/',
        component: Dashboard,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'jobs',
        path: '/jobs/',
        component: Jobs,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'RFIs',
        path: '/rfis/',
        component: RFIs,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'transmittals',
        path: '/transmittals/',
        component: Transmittals,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'project_journal',
        path: '/journal/',
        component: ProjectJournal,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'TimeTracking',
        path: '/timetracking/',
        component: TimeTracking,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'login',
        path: '/login/',
        component: Login,
        meta: {
            guest: true
        }
    },
    {
        name: 'Logout',
        path: '/logout/',
        component: Logout,
        meta: {
            requiresAuth: true
        }
    },
];

export default routes